<template>
  <div class="bigScreen-container">
    <PhotovoltaicScreen />
  </div>
</template>

<script>
import PhotovoltaicScreen from "../components/photovoltaic/PhotovoltaicScreen.vue";

export default {
  name: "BigScreen",
  components: {
    PhotovoltaicScreen,
  },
};
</script>

<style lang="scss" scoped>
.bigScreen-container {
  width: 100%;
  min-height: 100vh;
  height: 100%;
}
</style>
